<template>
    <component :is="iconComponent" :size="size" :color="color" :stroke-width="2" />
</template>

<script>
import {
    AlignCenter,
    Pilcrow,
    Hash,
    CircleDot,
    SquareCheck,
    ListFilter,
    CalendarDays,
    Tag,
    Trash2,
    Copy,
    ChevronDown,
    Plus,
    GripVertical,
    Pencil,
    X,
    ArrowLeft,
    ArrowUp,
    ArrowDown,
    Minus,
    Info,
    CirclePlus,
    MoreHorizontal,
    Search,
} from 'lucide-vue'

export default {
    name: 'FormTypeIcon',

    components: {
        AlignCenter,
        Pilcrow,
        Hash,
        CircleDot,
        SquareCheck,
        ListFilter,
        CalendarDays,
        Tag,
        Trash2,
        Copy,
        ChevronDown,
        Plus,
        GripVertical,
        Pencil,
        X,
        ArrowLeft,
        ArrowUp,
        ArrowDown,
        Minus,
        Info,
        CirclePlus,
        MoreHorizontal,
        Search,
    },

    props: {
        name: {
            type: String,
            required: true,
        },

        size: {
            type: [Number, String],
            default: 18,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },

    computed: {
        iconComponent() {
            const icons = {
                short: 'AlignCenter',
                long: 'Pilcrow',
                number: 'Hash',
                radio: 'CircleDot',
                checkbox: 'SquareCheck',
                select: 'ListFilter',
                date: 'CalendarDays',
                experience: 'Tag',
                trash: 'Trash2',
                copy: 'Copy',
                'chevron-down': 'ChevronDown',
                plus: 'Plus',
                drag: 'GripVertical',
                edit: 'Pencil',
                close: 'X',
                'arrow-left': 'ArrowLeft',
                'arrow-up': 'ArrowUp',
                'arrow-down': 'ArrowDown',
                minus: 'Minus',
                info: 'Info',
                'plus-circle': 'CirclePlus',
                'more-h': 'MoreHorizontal',
                search: 'Search',
            }

            return icons[this.name] || 'Info'
        },
    },
}
</script>
